/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Notification(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 18 20" fill="none" height={size} width={size} {...other}>
      <path
        d="M7.521 18.5H10.478M14.5 15.359V15.359C15.547 15.359 16.3967 14.512 16.4 13.465V13.465C16.3993 12.9323 16.1867 12.4217 15.809 12.046L14.55 10.786V7.04299V7.04399C14.55 3.98212 12.0679 1.49999 9.006 1.49999C9.00433 1.49999 9.00267 1.49999 9.001 1.49999H9.001C5.94031 1.5011 3.45955 3.9823 3.459 7.04299V10.783L2.2 12.043V12.043C1.82204 12.4186 1.60904 12.9291 1.608 13.462V13.462C1.6113 14.509 2.46098 15.356 3.50798 15.356L14.5 15.359Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Notification.defaultProps = {
  color: "currentColor",
  size: 24,
};

Notification.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
